import AllhomesCollapsibleDescription from './allhomes-collapsible-description';
export default AllhomesCollapsibleDescription;